import React from "react";
import styled from "styled-components";

const Center = styled.div.attrs(props => ({}))`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: ${props => (props.maxWidth ? props.maxWidth : "2000px")};
`;

const StretchedDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const RightDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const FullPageDiv = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default Center;

export const Stretch = ({ children }) => {
  return <StretchedDiv>{children}</StretchedDiv>;
};

export const Right = ({ children }) => {
  return <RightDiv>{children}</RightDiv>;
};

export const FullPage = ({ children }) => {
  return <FullPageDiv>{children}</FullPageDiv>;
};
